// The style catalogue CGDream drives its LoRA filters from, fetched once from its public
// `prompt_filters/suggestions` endpoint. NSFW entries are excluded the same way CGDream's
// own useFiltersPopup excludes them: anything tagged `adult`, plus every `premium` entry.
//
// Covers are served from CGTrader's public bucket, keyed by the style id, so nothing is
// bundled. The 53 styles whose cover has not been uploaded yet are commented out below
// rather than listed without one - see broken-style-images.csv. Uncomment an entry once
// its .webp lands in the bucket.
const STYLE_IMAGE_BASE = 'https://files.cgtrader.com/public_files/generator-styles'

export const styleImageUrl = styleId => `${STYLE_IMAGE_BASE}/${styleId}.webp`

export const STYLE_TAG_ALL = 'all'

export const STYLE_TAGS = [
  { id: STYLE_TAG_ALL, name: 'All' },
  { id: 'style', name: 'Style' },
  { id: 'character', name: 'Character' },
  { id: 'environment', name: 'Environment' },
  { id: 'theme', name: 'Theme' },
  { id: 'material', name: 'Material' },
  { id: 'effect', name: 'Effect' },
  { id: 'object', name: 'Object' },
  { id: 'enhancer', name: 'Enhancer' },
  { id: 'abstract', name: 'Abstract' },
]

export const STYLES = [
  { id: 'cgtrader_cartoon_illustration', name: 'Cartoon Illustration', tags: ['character', 'style'] },
  { id: 'cgtrader_comics', name: 'Comics', tags: ['style'] },
  { id: 'cgtrader_3d_game_environment', name: '3D Game Environment', tags: ['environment', 'object', 'theme'] },
  // { id: 'cgtrader_animals_reptile', name: 'Reptile', tags: ['character'] },
  { id: 'cgtrader_amber', name: 'Amber', tags: ['material', 'style'] },
  { id: 'cgtrader_circuit_board_material', name: 'Circuit Board Material', tags: ['material', 'style'] },
  { id: 'cgtrader_concept_art', name: 'Concept Art', tags: ['effect', 'theme'] },
  { id: 'cgtrader_bread', name: 'Bread', tags: ['material', 'object'] },
  { id: 'cgtrader_cake_frosting', name: 'Cake Frosting', tags: ['object'] },
  { id: 'cgtrader_decay', name: 'Decay', tags: ['effect', 'material'] },
  { id: 'cgtrader_flowers', name: 'Flowers', tags: ['object'] },
  { id: 'cgtrader_aircraft_spacecraft', name: 'Spacecraft', tags: ['object'] },
  { id: 'cgtrader_glowing_runes', name: 'Glowing Runes', tags: ['abstract', 'object', 'style'] },
  { id: 'cgtrader_duality', name: 'Duality', tags: ['abstract', 'style'] },
  { id: 'cgtrader_cyberpunk', name: 'Cyberpunk', tags: ['style', 'theme'] },
  { id: 'cgtrader_egyptian', name: 'Egyptian', tags: ['character', 'theme'] },
  { id: 'cgtrader_fabric', name: 'Fabric', tags: ['material'] },
  { id: 'cgtrader_holes', name: 'Holes', tags: ['effect'] },
  { id: 'cgtrader_fruit_and_vegetable_art', name: 'Fruit And Vegetable Art', tags: ['material', 'style'] },
  { id: 'cgtrader_animals_birds_of_prey', name: 'Birds Of Prey', tags: ['character'] },
  { id: 'cgtrader_game_map', name: 'Game Map', tags: ['environment', 'theme'] },
  { id: 'cgtrader_holy_magic', name: 'Holy Magic', tags: ['theme'] },
  { id: 'cgtrader_led', name: 'Led', tags: ['material'] },
  { id: 'cgtrader_crayon_drawing', name: 'Crayon Drawing', tags: ['material', 'style'] },
  { id: 'cgtrader_mushrooms', name: 'Mushrooms', tags: ['material', 'theme'] },
  { id: 'cgtrader_overgrown', name: 'Overgrown', tags: ['effect', 'material'] },
  { id: 'cgtrader_pearls', name: 'Pearls', tags: ['material'] },
  { id: 'cgtrader_mc_escher', name: 'M.C. Escher', tags: ['abstract', 'effect', 'environment', 'style'] },
  { id: 'cgtrader_adornments', name: 'Adornments', tags: ['material', 'style'] },
  { id: 'cgtrader_sparkling', name: 'Sparkling', tags: ['effect', 'material'] },
  { id: 'cgtrader_spider_web', name: 'Spider Web', tags: ['material', 'style'] },
  { id: 'cgtrader_vector_art', name: 'Vector Art', tags: ['style'] },
  { id: 'cgtrader_self-illuminated', name: 'Self-Illuminated', tags: ['effect'] },
  { id: 'cgtrader_people', name: 'People', tags: [] },
  { id: 'cgtrader_machinery', name: 'Machinery', tags: ['material', 'style'] },
  { id: 'cgtrader_meat', name: 'Meat', tags: ['material'] },
  { id: 'cgtrader_middle_east_ornaments', name: 'Middle East Ornaments', tags: ['abstract', 'style'] },
  { id: 'cgtrader_minimalist_photography', name: 'Minimalist Photography', tags: ['abstract', 'effect'] },
  { id: 'cgtrader_old_asian_art', name: 'Old Asian Art', tags: ['style'] },
  { id: 'cgtrader_pixelated', name: 'Pixelated', tags: ['effect'] },
  { id: 'cgtrader_plushie', name: 'Plushie', tags: ['object'] },
  { id: 'cgtrader_portal_fantasy', name: 'Portal Fantasy', tags: ['abstract', 'style', 'theme'] },
  { id: 'cgtrader_exterior_house', name: 'Modern House', tags: ['environment'] },
  { id: 'cgtrader_ice_material', name: 'Ice Material', tags: ['material'] },
  { id: 'cgtrader_industrial_abandoned_sites', name: 'Industrial Abandoned', tags: ['environment'] },
  { id: 'cgtrader_material_lava', name: 'Material Lava', tags: ['effect', 'material'] },
  { id: 'cgtrader_aircraft_jet-plane', name: 'Aircraft Jet-plane', tags: ['object'] },
  { id: 'cgtrader_vampire', name: 'Vampire', tags: ['character'] },
  { id: 'cgtrader_barbarian', name: 'Barbarian', tags: ['character'] },
  { id: 'cgtrader_product_ad', name: 'Product Ad', tags: ['object', 'theme'] },
  { id: 'cgtrader_soap_bubble', name: 'Soap Bubble', tags: ['effect'] },
  { id: 'cgtrader_sunset', name: 'Sunset', tags: ['environment', 'theme'] },
  { id: 'cgtrader_velvet', name: 'Velvet', tags: ['effect', 'material'] },
  { id: 'cgtrader_fantasy_character', name: 'Fantasy Character', tags: ['character', 'style'] },
  { id: 'cgtrader_animals_wild_cats', name: 'Wild Cats', tags: ['character'] },
  { id: 'cgtrader_ad_effects', name: 'Ad Effects', tags: ['effect'] },
  { id: 'cgtrader_bricks', name: 'Bricks', tags: ['material', 'object'] },
  { id: 'cgtrader_carbon_fiber', name: 'Carbon Fiber', tags: ['material'] },
  { id: 'cgtrader_game_asset', name: 'Game Asset', tags: ['style', 'theme'] },
  { id: 'cgtrader_chocolate', name: 'Chocolate', tags: ['material', 'object'] },
  { id: 'cgtrader_game_character', name: 'Game Character', tags: ['character', 'environment', 'style'] },
  { id: 'cgtrader_wicker', name: 'Wicker', tags: ['material', 'object'] },
  // { id: 'cgtrader_abstract_design', name: 'Abstract Design', tags: ['abstract', 'style'] },
  // { id: 'cgtrader_abstract_line_drawing', name: 'Abstract Line Drawing', tags: ['abstract', 'style'] },
  // { id: 'cgtrader_animals_dinosaur', name: 'Dinosaurs', tags: ['character'] },
  // { id: 'cgtrader_animals_insect', name: 'Insect', tags: ['character'] },
  // { id: 'cgtrader_black_and_white_old_cartoon', name: 'Black And White Old Cartoon', tags: ['style'] },
  // { id: 'cgtrader_epic_fantasy_environment', name: 'Epic Fantasy Environment', tags: ['environment', 'theme'] },
  // { id: 'cgtrader_low-poly', name: 'Low-Poly', tags: ['style'] },
  // { id: 'cgtrader_manga_comic', name: 'Manga Comic', tags: ['style'] },
  // { id: 'cgtrader_plasma', name: 'Plasma', tags: ['effect'] },
  // { id: 'cgtrader_voxel', name: 'Voxel', tags: ['style'] },
  // { id: 'cgtrader_x-ray', name: 'X-Ray', tags: ['effect', 'style'] },
  { id: 'cgtrader_text_design_realistic', name: 'Text Design Realistic', tags: ['style'] },
  { id: 'cgtrader_glitter', name: 'Glitter', tags: ['effect'] },
  { id: 'cgtrader_jeans_denim', name: 'Jeans Denim', tags: ['material'] },
  { id: 'cgtrader_portal_sci-fi', name: 'Portal Sci-Fi', tags: ['style', 'theme'] },
  { id: 'cgtrader_sand', name: 'Sand', tags: ['material'] },
  { id: 'cgtrader_smile', name: 'Smile', tags: ['character', 'effect'] },
  { id: 'cgtrader_spaghetti', name: 'Spaghetti', tags: ['object'] },
  { id: 'cgtrader_teenager', name: 'Teenager', tags: ['character'] },
  { id: 'cgtrader_tilt-shift', name: 'Tilt-Shift', tags: ['style'] },
  { id: 'cgtrader_water_droplets', name: 'Water Droplets', tags: ['material', 'object'] },
  { id: 'cgtrader_wax', name: 'Wax', tags: ['material'] },
  { id: 'cgtrader_wire', name: 'Wire', tags: ['material'] },
  { id: 'cgtrader_abstract_3d_fractals', name: 'Abstract 3D Fractals', tags: ['abstract', 'effect', 'style'] },
  { id: 'cgtrader_abstract_dark_shapes', name: 'Abstract Dark Shapes', tags: ['abstract', 'style'] },
  { id: 'cgtrader_food_fruit', name: 'Fruit', tags: ['object'] },
  // { id: 'cgtrader_art_collage', name: 'Art Collage', tags: ['style'] },
  { id: 'cgtrader_abstract_electricity', name: 'Electricity Abstract', tags: ['abstract', 'effect'] },
  // { id: 'cgtrader_animals_fish', name: 'Fish', tags: ['character'] },
  // { id: 'cgtrader_animals_wolves', name: 'Wolves', tags: ['character'] },
  { id: 'cgtrader_abstract_light_shapes', name: 'Abstract Light Shapes', tags: ['abstract', 'style'] },
  // { id: 'cgtrader_charcoal', name: 'Charcoal', tags: ['style'] },
  // { id: 'cgtrader_claymation', name: 'Claymation', tags: ['style'] },
  { id: 'cgtrader_abstract_structures', name: 'Abstract Structures', tags: ['abstract', 'style'] },
  // { id: 'cgtrader_comic_b_and_w_illustration', name: 'Comic B&W Illustration', tags: ['style'] },
  // { id: 'cgtrader_doodle_illustration', name: 'Doodle Illustration', tags: ['style'] },
  { id: 'cgtrader_abstract_sculpture', name: 'Abstract Sculpture', tags: ['abstract', 'object'] },
  { id: 'cgtrader_abstract_waves', name: 'Abstract Waves', tags: ['abstract', 'style'] },
  // { id: 'cgtrader_epic_environment', name: 'Epic Environment', tags: ['environment', 'theme'] },
  // { id: 'cgtrader_epic_sci-fi_environment', name: 'Epic Sci-Fi Environment', tags: ['environment', 'theme'] },
  { id: 'cgtrader_animals_rodents', name: 'Rodents', tags: ['character'] },
  { id: 'cgtrader_aircraft_aerial_views', name: 'Aerial View', tags: ['environment'] },
  // { id: 'cgtrader_fight_scene', name: 'Fight Scene', tags: ['theme'] },
  // { id: 'cgtrader_fog', name: 'Fog', tags: ['effect', 'environment'] },
  { id: 'cgtrader_alien', name: 'Alien', tags: ['character'] },
  { id: 'cgtrader_alien_worlds', name: 'Alien Worlds', tags: ['environment'] },
  { id: 'cgtrader_anthropomorphic_animal', name: 'Anthropomorphic Animal', tags: ['character'] },
  { id: 'cgtrader_animals_mammal', name: 'Animals', tags: ['character'] },
  { id: 'cgtrader_aircraft_drones', name: 'Aircraft Drones', tags: ['object'] },
  { id: 'cgtrader_animals_horses', name: 'Horses', tags: ['character'] },
  { id: 'cgtrader_architectural_exterior_art_deco', name: 'Architectural Exterior Art Deco', tags: ['environment'] },
  { id: 'cgtrader_architectural_exterior_brutalism', name: 'Architectural Exterior Brutalism', tags: ['environment'] },
  // { id: 'cgtrader_fragmented', name: 'Fragmented', tags: ['effect', 'material', 'style'] },
  { id: 'cgtrader_architectural_exterior_castles', name: 'Castles', tags: ['environment'] },
  { id: 'cgtrader_architectural_exterior_gothic', name: 'Gothic Architecture', tags: ['environment'] },
  { id: 'cgtrader_abstract_illustration', name: 'Abstract Illustration', tags: ['abstract', 'style'] },
  // { id: 'cgtrader_illustration', name: 'Illustration', tags: ['style'] },
  // { id: 'cgtrader_india_ornaments', name: 'India Ornaments', tags: ['style'] },
  // { id: 'cgtrader_line_art', name: 'Line Art', tags: ['style'] },
  { id: 'cgtrader_ancient_ruins', name: 'Ancient Ruins', tags: ['environment'] },
  // { id: 'cgtrader_long_exposure', name: 'Long Exposure', tags: ['style'] },
  { id: 'cgtrader_car_concept', name: 'Car Concept', tags: ['object'] },
  // { id: 'cgtrader_material_concrete', name: 'Material Concrete', tags: ['material'] },
  // { id: 'cgtrader_music_instruments', name: 'Music Instruments', tags: ['object'] },
  // { id: 'cgtrader_mythological_creatures', name: 'Mythological Creatures', tags: ['character', 'theme'] },
  // { id: 'cgtrader_opal', name: 'Opal', tags: ['material'] },
  { id: 'cgtrader_car_interior', name: 'Car Interior', tags: ['environment'] },
  // { id: 'cgtrader_pointillism', name: 'Pointillism', tags: ['style'] },
  // { id: 'cgtrader_retro_sci-fi', name: 'Retro Sci-Fi', tags: ['style', 'theme'] },
  { id: 'cgtrader_evil_character', name: 'Evil Character', tags: ['character'] },
  { id: 'cgtrader_architectural_exterior_green_buildings', name: 'Green Buildings', tags: ['environment'] },
  { id: 'cgtrader_ancient_architecture', name: 'Ancient Architecture', tags: ['environment'] },
  // { id: 'cgtrader_rounded_vector_art', name: 'Rounded Vector Art', tags: ['style'] },
  { id: 'cgtrader_abstract_corals', name: 'Abstract Corals', tags: ['abstract', 'style'] },
  { id: 'cgtrader_aircraft_commercial', name: 'Aircraft Commercial', tags: ['object'] },
  { id: 'cgtrader_3d_cartoon', name: '3D Cartoon', tags: ['style'] },
  // { id: 'cgtrader_cel-shaded_illustration', name: 'Cel-Shaded Illustration', tags: ['style'] },
  // { id: 'cgtrader_clouds', name: 'Clouds', tags: ['effect', 'theme'] },
  // { id: 'cgtrader_digital_painting', name: 'Digital Painting', tags: ['style'] },
  {
    id: 'cgtrader_architectural_exterior_skyscrapers',
    name: 'Architectural Exterior Skyscrapers',
    tags: ['environment'],
  },
  { id: 'cgtrader_architectural_street', name: 'City Street', tags: ['environment'] },
  { id: 'cgtrader_angel', name: 'Angel', tags: ['character'] },
  { id: 'cgtrader_anime', name: 'Anime', tags: ['theme'] },
  // { id: 'cgtrader_light_and_silhouette', name: 'Light & Silhouette', tags: ['style'] },
  // { id: 'cgtrader_flat_illustration', name: 'Flat Illustration', tags: ['style'] },
  // { id: 'cgtrader_impasto_painting', name: 'Impasto Painting', tags: ['style'] },
  // { id: 'cgtrader_layers', name: 'Layers', tags: ['effect', 'style'] },
  { id: 'cgtrader_art_abstract', name: 'Liquid Abstract Art', tags: ['abstract', 'effect', 'style'] },
  // { id: 'cgtrader_section', name: 'Section', tags: ['effect', 'style'] },
  { id: 'cgtrader_art_graffiti', name: 'Graffiti Art', tags: ['style'] },
  // { id: 'cgtrader_soft_surrealism', name: 'Soft Surrealism', tags: ['style'] },
  // { id: 'cgtrader_volumetric_lighting', name: 'Volumetric Lighting', tags: ['effect', 'style'] },
  { id: 'cgtrader_art_surrealism', name: 'Surrealism', tags: ['style', 'theme'] },
  { id: 'cgtrader_art_watercolor', name: 'Watercolor Style', tags: ['style'] },
  // { id: 'cgtrader_wavy', name: 'Wavy', tags: ['effect', 'style'] },
  // { id: 'cgtrader_zebra_stripes', name: 'Zebra Stripes', tags: ['effect', 'style'] },
  { id: 'cgtrader_bioluminescence_in_organisms', name: 'Bioluminescence In Organisms', tags: ['effect', 'material'] },
  { id: 'cgtrader_broadleaf_trees', name: 'Broadleaf Trees', tags: ['environment', 'object'] },
  { id: 'cgtrader_bubbles_abstract_art', name: 'Bubbles Abstract Art', tags: ['abstract', 'style'] },
  { id: 'cgtrader_candy', name: 'Candy', tags: ['material'] },
  { id: 'cgtrader_car_antique', name: 'Antique Car', tags: ['object'] },
  { id: 'cgtrader_car_luxury', name: 'Luxury Car', tags: ['object'] },
  { id: 'cgtrader_car_racing', name: 'Car Racing', tags: ['object'] },
  { id: 'cgtrader_car_sport', name: 'Sports Car', tags: ['object'] },
  { id: 'cgtrader_car_suv', name: 'Suv Car', tags: ['object'] },
  { id: 'cgtrader_cartoon_fantasy_cartoons', name: 'Cartoon Fantasy', tags: ['theme'] },
  { id: 'cgtrader_cartoon_funny_animals', name: '3D Cartoon Animals', tags: ['character', 'style'] },
  { id: 'cgtrader_cartoon_horror_cartoons', name: 'Cartoon Horror', tags: ['style'] },
  { id: 'cgtrader_cartoon_manga', name: 'Manga Cartoon', tags: ['style'] },
  { id: 'cgtrader_cartoon_mythical_creatures', name: 'Cartoon Creatures', tags: ['character', 'style'] },
  { id: 'cgtrader_chalets', name: 'Chalets', tags: ['environment'] },
  { id: 'cgtrader_chalk_drawing', name: 'Chalk Drawing', tags: ['style'] },
  { id: 'cgtrader_caricature', name: 'Caricature', tags: ['style'] },
  { id: 'cgtrader_character', name: 'Character', tags: ['character', 'enhancer'] },
  { id: 'cgtrader_character_anatomy', name: 'Human Anatomy', tags: ['character'] },
  { id: 'cgtrader_character_child', name: 'Child', tags: ['character'] },
  { id: 'cgtrader_character_fantasy', name: 'Woman Fantasy', tags: ['character'] },
  { id: 'cgtrader_character_historical', name: 'Character Historical', tags: ['character'] },
  { id: 'cgtrader_cheese', name: 'Cheese', tags: ['material'] },
  { id: 'cgtrader_copper', name: 'Copper', tags: ['material'] },
  { id: 'cgtrader_cityscapes_cities_in_winter', name: 'Cityscape In Winter', tags: ['environment'] },
  { id: 'cgtrader_cosmic', name: 'Cosmic', tags: ['environment', 'theme'] },
  { id: 'cgtrader_clay_render', name: 'Clay Render', tags: ['material'] },
  { id: 'cgtrader_christmas', name: 'Christmas', tags: ['theme'] },
  { id: 'cgtrader_cityscapes', name: 'Cityscapes', tags: ['environment'] },
  { id: 'cgtrader_cracks', name: 'Cracks', tags: ['effect', 'material'] },
  { id: 'cgtrader_creative_enhancer', name: 'Creative Enhancer', tags: ['enhancer', 'style'] },
  { id: 'cgtrader_crystalize', name: 'Crystalize', tags: ['effect', 'material'] },
  { id: 'cgtrader_cute_monsters', name: 'Cute Monsters', tags: ['character'] },
  { id: 'cgtrader_demon', name: 'Demon', tags: ['character'] },
  { id: 'cgtrader_desert_dunes', name: 'Desert', tags: ['environment'] },
  { id: 'cgtrader_dynamic_abstract_shapes', name: 'Dynamic Abstract Shapes', tags: ['abstract'] },
  { id: 'cgtrader_electrify', name: 'Electrify', tags: ['effect', 'style'] },
  { id: 'cgtrader_explode', name: 'Explode', tags: ['effect', 'theme'] },
  { id: 'cgtrader_frost_macro', name: 'Frost Macro', tags: ['material'] },
  { id: 'cgtrader_cyborg', name: 'Cyborg', tags: ['character'] },
  { id: 'cgtrader_diamonds', name: 'Diamonds', tags: ['material'] },
  { id: 'cgtrader_exterior_rural', name: 'Rural House', tags: ['environment'] },
  { id: 'cgtrader_fantasy_alternate_realities', name: 'Surrealistic Alternate Realities', tags: ['environment'] },
  { id: 'cgtrader_fantasy_cinematic', name: 'Fantasy Cinematic', tags: ['style', 'theme'] },
  { id: 'cgtrader_fantasy_dark_fantasy', name: 'Dark Magic', tags: ['theme'] },
  { id: 'cgtrader_fantasy_dragons', name: 'Fantasy Dragons', tags: ['character'] },
  { id: 'cgtrader_fantasy_dystopian_fantasy', name: 'Dystopian Apocalyptic', tags: ['theme'] },
  { id: 'cgtrader_fantasy_epic_battles', name: 'Battle Fantasy', tags: ['theme'] },
  { id: 'cgtrader_fantasy_fairy_tales', name: 'Fairy Tales', tags: ['theme'] },
  { id: 'cgtrader_fantasy_magical_creatures', name: 'Magical Creatures', tags: ['character'] },
  { id: 'cgtrader_exterior_futuristic', name: 'Futuristic House', tags: ['environment'] },
  { id: 'cgtrader_fantasy_painting', name: 'Fantasy Painting', tags: ['style', 'theme'] },
  { id: 'cgtrader_fashion_business', name: 'Fashion Business', tags: ['character'] },
  { id: 'cgtrader_fashion_casual', name: 'Fashion Casual', tags: ['character'] },
  { id: 'cgtrader_fashion_luxurious', name: 'Fashion Luxury', tags: ['character'] },
  { id: 'cgtrader_fashion_photography', name: 'Fashion Eccentric', tags: ['character'] },
  { id: 'cgtrader_fluid_illustration', name: 'Fluid Illustration', tags: ['style'] },
  { id: 'cgtrader_food_beverage', name: 'Food Beverage', tags: ['object'] },
  { id: 'cgtrader_fire_material', name: 'Fire', tags: ['effect', 'material'] },
  { id: 'cgtrader_forest', name: 'Forest', tags: ['environment'] },
  { id: 'cgtrader_fractured', name: 'Fractured', tags: ['effect', 'material'] },
  { id: 'cgtrader_feather', name: 'Feather', tags: ['material'] },
  { id: 'cgtrader_fumes_abstract_art', name: 'Fumes', tags: ['abstract', 'effect'] },
  { id: 'cgtrader_fur', name: 'Fur', tags: ['effect', 'material'] },
  { id: 'cgtrader_furniture_chair', name: 'Chair', tags: ['object'] },
  { id: 'cgtrader_geometry_abstract_art', name: 'Geometry Abstract Art', tags: ['abstract'] },
  { id: 'cgtrader_golden', name: 'Golden', tags: ['material'] },
  { id: 'cgtrader_historical', name: 'Classical Architecture', tags: ['environment', 'theme'] },
  { id: 'cgtrader_historical_roman_empire', name: 'Roman Empire', tags: ['theme'] },
  { id: 'cgtrader_historical_victorian', name: 'Victorian Era', tags: ['theme'] },
  { id: 'cgtrader_historical_vikings', name: 'Vikings', tags: ['character'] },
  { id: 'cgtrader_historical_wild_west', name: 'Western Style', tags: ['character'] },
  { id: 'cgtrader_hologram', name: 'Hologram', tags: ['effect', 'style', 'theme'] },
  { id: 'cgtrader_historical_medieval', name: 'Medieval Age', tags: ['theme'] },
  { id: 'cgtrader_horror', name: 'Horror', tags: ['theme'] },
  { id: 'cgtrader_horror_abstract_art', name: 'Horror Surrealism', tags: ['theme'] },
  { id: 'cgtrader_house_beach_houses', name: 'Beach Houses', tags: ['environment'] },
  { id: 'cgtrader_house_farmhouses', name: 'House Farmhouses', tags: ['environment'] },
  { id: 'cgtrader_interior_hall', name: 'Interior Hall', tags: ['environment'] },
  { id: 'cgtrader_interior_house', name: 'Modern House Interior', tags: ['environment'] },
  { id: 'cgtrader_interior_living_room', name: 'Living Room', tags: ['environment'] },
  { id: 'cgtrader_intricate_illustration', name: 'Intricate Illustration', tags: ['style'] },
  { id: 'cgtrader_industrial_machine', name: 'Industrial Machine', tags: ['theme'] },
  { id: 'cgtrader_interior_bathroom', name: 'Bathroom', tags: ['environment'] },
  { id: 'cgtrader_interior_bedroom', name: 'Bedroom', tags: ['environment'] },
  { id: 'cgtrader_interior_kitchen', name: 'Modern Kitchen', tags: ['environment'] },
  { id: 'cgtrader_ivy_and_vines', name: 'Ivy And Vines', tags: ['effect', 'material'] },
  { id: 'cgtrader_knight', name: 'Knight', tags: ['character'] },
  { id: 'cgtrader_knitted_wool', name: 'Knitted Wool', tags: ['material'] },
  { id: 'cgtrader_landmark_lighthouses', name: 'Landmark Lighthouse', tags: ['environment'] },
  { id: 'cgtrader_lattice', name: 'Lattice', tags: ['material'] },
  { id: 'cgtrader_leather', name: 'Leather', tags: ['material'] },
  { id: 'cgtrader_material_matte', name: 'Material Matte', tags: ['material'] },
  { id: 'cgtrader_liquid_abstract_art', name: 'Liquid', tags: ['abstract', 'style'] },
  { id: 'cgtrader_macro_abstract_art', name: 'Macro Abstract Art', tags: ['abstract', 'style'] },
  { id: 'cgtrader_material_glossy', name: 'Material Glossy', tags: ['material'] },
  { id: 'cgtrader_material_marble', name: 'Material Marble', tags: ['material'] },
  { id: 'cgtrader_material_metallic', name: 'Material Metallic', tags: ['material'] },
  { id: 'cgtrader_material_rock', name: 'Material Rock', tags: ['material'] },
  { id: 'cgtrader_material_stone', name: 'Material Stone', tags: ['material'] },
  { id: 'cgtrader_material_wood', name: 'Material Wood', tags: ['material'] },
  { id: 'cgtrader_melting', name: 'Melting', tags: ['effect', 'style'] },
  { id: 'cgtrader_military_armor', name: 'Military Armor', tags: ['character'] },
  { id: 'cgtrader_military_melee', name: 'Melee Weapon', tags: ['character'] },
  { id: 'cgtrader_minerals', name: 'Minerals', tags: ['material'] },
  { id: 'cgtrader_moss', name: 'Moss', tags: ['effect', 'material'] },
  { id: 'cgtrader_motion_blur', name: 'Motion Blur', tags: ['effect'] },
  { id: 'cgtrader_mountains', name: 'Mountains', tags: ['environment'] },
  { id: 'cgtrader_mycelium_fungus', name: 'Mycelium Fungus', tags: ['material'] },
  { id: 'cgtrader_pirate', name: 'Pirate', tags: ['character'] },
  { id: 'cgtrader_monster', name: 'Monster', tags: ['character'] },
  { id: 'cgtrader_military_character', name: 'Modern Soldier', tags: ['character'] },
  { id: 'cgtrader_natural_landmarks', name: 'Natural Landmarks', tags: ['environment'] },
  { id: 'cgtrader_oil_painting', name: 'Oil Painting', tags: ['style'] },
  { id: 'cgtrader_organic_abstract_art', name: 'Organic Abstract Art', tags: ['abstract', 'style'] },
  { id: 'cgtrader_organic_architecture', name: 'Organic Architecture', tags: ['environment'] },
  { id: 'cgtrader_ornaments_abstract_art', name: 'Ornaments Abstract Art', tags: ['abstract', 'style'] },
  { id: 'cgtrader_pencil_drawing', name: 'Pencil Drawing', tags: ['style'] },
  { id: 'cgtrader_photo_man', name: 'Man Realistic', tags: ['character'] },
  { id: 'cgtrader_photorealistic_surrealism', name: 'Photorealistic Surrealism', tags: ['style'] },
  { id: 'cgtrader_nature_winter', name: 'Nature Winter', tags: ['environment'] },
  { id: 'cgtrader_old_man', name: 'Old Man', tags: ['character'] },
  { id: 'cgtrader_old_woman', name: 'Old Woman', tags: ['character'] },
  { id: 'cgtrader_ink_art', name: 'Ink Art', tags: ['style'] },
  { id: 'cgtrader_planetscape', name: 'Planetscape', tags: ['environment'] },
  { id: 'cgtrader_plant_grass', name: 'Plant Grass', tags: ['environment', 'material'] },
  { id: 'cgtrader_plant_leaf', name: 'Plant Leaf', tags: ['material'] },
  { id: 'cgtrader_porcelain', name: 'Porcelain', tags: ['material'] },
  { id: 'cgtrader_portrait_effects', name: 'Portrait Effects', tags: ['effect', 'enhancer'] },
  { id: 'cgtrader_psychedelic_surrealism', name: 'Psychedelic Surrealism', tags: ['style'] },
  { id: 'cgtrader_rain', name: 'Rain', tags: ['effect', 'theme'] },
  { id: 'cgtrader_rainbow', name: 'Rainbow', tags: ['effect', 'style'] },
  { id: 'cgtrader_realistic_woman', name: 'Woman Realistic', tags: ['character'] },
  { id: 'cgtrader_retro', name: 'Retro', tags: ['style', 'theme'] },
  { id: 'cgtrader_robot', name: 'Robot', tags: ['character'] },
  { id: 'cgtrader_robot_cute', name: 'Robot Cute', tags: ['character'] },
  { id: 'cgtrader_robot_rusty', name: 'Robot Old', tags: ['character'] },
  { id: 'cgtrader_roots', name: 'Roots', tags: ['effect', 'material'] },
  { id: 'cgtrader_royal', name: 'Royal', tags: ['style', 'theme'] },
  { id: 'cgtrader_rusty', name: 'Rusty', tags: ['material'] },
  { id: 'cgtrader_samurai', name: 'Samurai', tags: ['character'] },
  { id: 'cgtrader_sci-fi_abstract_art', name: 'Sci-Fi Abstract Art', tags: ['abstract', 'style'] },
  { id: 'cgtrader_sci-fi_character', name: 'Sci-Fi Character', tags: ['character'] },
  { id: 'cgtrader_sci-fi_style', name: 'Sci-Fi Style', tags: ['style', 'theme'] },
  { id: 'cgtrader_scratched_and_worn', name: 'Scratched And Worn', tags: ['material', 'style'] },
  { id: 'cgtrader_skull', name: 'Skull', tags: ['object'] },
  { id: 'cgtrader_smooth_shapes_abstract_art', name: 'Abstract Smooth Shapes', tags: ['abstract'] },
  { id: 'cgtrader_sci-fi_environment', name: 'Sci-Fi Environment', tags: ['environment'] },
  { id: 'cgtrader_snow', name: 'Snow', tags: ['material'] },
  { id: 'cgtrader_space_exploration', name: 'Space Exploration', tags: ['theme'] },
  { id: 'cgtrader_space_planet', name: 'Space Planet', tags: ['environment'] },
  { id: 'cgtrader_sponge', name: 'Sponge', tags: ['material'] },
  { id: 'cgtrader_stripes', name: 'Stripes', tags: ['effect', 'material'] },
  { id: 'cgtrader_surreal_fantasy_building', name: 'Surreal Fantasy Building', tags: ['environment'] },
  { id: 'cgtrader_surreal_modern_architecture', name: 'Surreal Modern Architecture', tags: ['environment'] },
  { id: 'cgtrader_swirl', name: 'Swirl', tags: ['effect', 'style'] },
  { id: 'cgtrader_textile', name: 'Textile', tags: ['material'] },
  { id: 'cgtrader_translucent', name: 'Translucent', tags: ['effect', 'material'] },
  { id: 'cgtrader_text_design_illustration', name: 'Text Design Illustration', tags: ['style'] },
  { id: 'cgtrader_underwater', name: 'Underwater', tags: ['theme'] },
  { id: 'cgtrader_vehicle_motorcycle', name: 'Motorcycle', tags: ['object'] },
  { id: 'cgtrader_vehicle_military-vehicle', name: 'Military Vehicle', tags: ['object'] },
  { id: 'cgtrader_vibrant_illustration', name: 'Vibrant Illustration', tags: ['style'] },
  { id: 'cgtrader_water_material', name: 'Water Material', tags: ['material'] },
  { id: 'cgtrader_watercraft_historic', name: 'Watercraft Historic', tags: ['theme'] },
  { id: 'cgtrader_wave', name: 'Sea Waves', tags: ['effect', 'material'] },
  { id: 'cgtrader_werewolf', name: 'Werewolf', tags: ['character'] },
  { id: 'cgtrader_winter', name: 'Winter', tags: ['environment'] },
  { id: 'cgtrader_witch', name: 'Witch', tags: ['character'] },
  { id: 'cgtrader_wizard', name: 'Wizard', tags: ['character'] },
  { id: 'external_landscape_enhancer', name: 'Landscape Enhancer', tags: ['enhancer', 'environment'] },
  { id: 'external_3d_redmond_v1', name: '3d Redmond V1 by artificialguybr', tags: ['style'] },
  { id: 'external_abstract_painting_style', name: 'Abstract Painting Style', tags: ['style'] },
  { id: 'external_action_photography_style', name: 'Action', tags: ['effect', 'enhancer'] },
  { id: 'external_aether_bubbles_and_foam', name: 'Aether Bubbles And Foam by joachim_s', tags: ['effect'] },
  { id: 'external_aether_ghost', name: 'Aether Ghost by joachim_s', tags: ['character'] },
  { id: 'external_yamer_style', name: 'Yamer\'s Style', tags: ['style'] },
  { id: 'external_aether_glitch', name: 'Aether Glitch by joachim_s', tags: ['style'] },
  { id: 'external_alien_god', name: 'Alien God by Ciro Negrogni', tags: ['character'] },
  { id: 'external_analogredmond', name: 'Analogredmond by artificialguybr', tags: ['style'] },
  { id: 'external_balloon_sculpture', name: 'Balloon Sculpture', tags: ['theme'] },
  { id: 'external_brass_steampunk', name: 'Brass Steampunk', tags: ['character', 'theme'] },
  { id: 'external_cd_music_cover', name: 'CD Music', tags: ['style'] },
  { id: 'external_logo_redmond', name: 'Logo Redmond by artificialguybr', tags: ['style'] },
  { id: 'external_made_of_iridescent_foil', name: 'Made Of Iridescent Foil by KappaNeuro', tags: ['material'] },
  // { id: 'external_clay_animation', name: 'Clay Animation by ArtificialGuyBR', tags: ['style'] },
  { id: 'external_cloud_figure', name: 'Cloud Figure by joachim_s', tags: ['character'] },
  { id: 'external_cute_fruits_redmond', name: 'Cute Fruits Redmond by artificialguybr', tags: ['style'] },
  { id: 'external_cyborg_style', name: 'Cyborg Style by goofyai', tags: ['character'] },
  { id: 'external_microverse_creator', name: 'Microverse Creator by Ciro Negrogni', tags: ['theme'] },
  { id: 'external_dressed_animals', name: 'Dressed Animals by Kappa_Neuro', tags: ['character'] },
  { id: 'external_embroidery_style', name: 'Embroidery Style', tags: ['style'] },
  // { id: 'external_enhance_art', name: 'Enhance Art by ledadu', tags: ['enhancer', 'style'] },
  { id: 'external_epic_beard', name: 'Epic Beard, Mustache & Hair', tags: ['character'] },
  { id: 'external_fantasy_art', name: 'Fantasy Art', tags: ['style', 'theme'] },
  { id: 'external_hair_style', name: 'Hair Style by CiroN2022', tags: ['character'] },
  { id: 'external_illustrative_funk', name: 'Illustrative Funk', tags: ['style'] },
  { id: 'external_juggernaut_cinematic', name: 'Juggernaut Cinematic by KandooAI', tags: ['style'] },
  { id: 'external_modern_oil_painting', name: 'Modern Oil Painting', tags: ['style'] },
  { id: 'external_mosaic', name: 'Mosaic by CiroN2022', tags: ['material', 'style'] },
  // { id: 'external_neon_sign', name: 'Neon Sign by ProomptEngineer', tags: ['effect', 'style'] },
  { id: 'external_split', name: 'Split', tags: ['character', 'effect', 'theme'] },
  // { id: 'external_papercut', name: 'Papercut by TheLastBen', tags: ['material', 'style'] },
  { id: 'external_perfect_eyes_xl', name: 'Perfect Eyes Xl by Deizor', tags: ['character', 'enhancer'] },
  { id: 'external_punk_collage', name: 'Punk Collage', tags: ['style'] },
  {
    id: 'external_rpg_fire_elemental_xl',
    name: 'Rpg Fire Elemental Xl by ashrpg',
    tags: ['character', 'effect', 'style'],
  },
  { id: 'external_sand_sculpter', name: 'Sand Sculpter by ProomptEngineer', tags: ['material'] },
  { id: 'external_sticker_sheet', name: 'Sticker Sheet', tags: ['style'] },
  { id: 'external_stickers_redmond', name: 'Stickers Redmond by artificialguybr', tags: ['style'] },
  // { id: 'external_stop_motion_animation', name: 'Stop Motion Animation by Kappa_Neuro', tags: ['style'] },
  { id: 'external_story_book_redmond_v2', name: 'Story Book', tags: ['style'] },
  { id: 'external_t-shirt_design_redmond_v2', name: 'T-shirt Design Redmond V2 by artificialguybr', tags: ['theme'] },
  { id: 'external_wool_yarn', name: 'Wool Yarn by Thaevilone', tags: ['material'] },
  { id: 'external_xl_fantasy_warriors', name: 'Xl Fantasy Warriors by HailoKnight', tags: ['character'] },
  { id: 'external_toy_pop_figure', name: 'Toy Pop Figure by ProomptEngineer', tags: ['character', 'style', 'theme'] },
  // { id: 'external_ukiyo', name: 'Ukiyo by KappaNeuro', tags: ['style'] },
  { id: 'external_vintage_action_figure', name: 'Vintage Action Figure', tags: ['character', 'style'] },
  { id: 'external_vintage_magazine_style', name: 'Vintage Magazine Style by Norod78', tags: ['style'] },
  { id: 'external_vintage_postage_stamps', name: 'Vintage Postage Stamps', tags: ['style'] },
  { id: 'external_voodoo_dolls', name: 'Voodoo Dolls', tags: ['theme'] },
  { id: 'external_voxel', name: 'Voxel by Fictiverse', tags: ['style'] },
  { id: 'external_william_eggleston_style', name: 'William Eggleston Style by TheLastBen', tags: ['style'] },
  { id: 'external_wings_powers', name: 'Wings and Powers', tags: ['character'] },
]
